import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/layouts/default.vue").then(m => m.default || m)),
  footered: defineAsyncComponent(() => import("/Users/ave/_dev/_projects/_dream3/bizlite/bizlite-main-fe/layouts/footered.vue").then(m => m.default || m))
}